import { useState, useEffect } from 'react'

/**
 * Hook для определения, является ли устройство мобильным
 * @param query - медиа-запрос (по умолчанию проверяет ширину экрана <= 768px)
 * @returns true, если запрос соответствует
 */
export function useMediaQuery(query: string = '(max-width: 768px)'): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.matchMedia(query).matches
    }
    return false
  })

  useEffect(() => {
    if (typeof window === 'undefined') return

    const mediaQuery = window.matchMedia(query)
    const handler = (event: MediaQueryListEvent) => {
      setMatches(event.matches)
    }

    // Проверяем, поддерживает ли браузер addEventListener
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handler)
      return () => mediaQuery.removeEventListener('change', handler)
    } else {
      // Fallback для старых браузеров
      mediaQuery.addListener(handler)
      return () => mediaQuery.removeListener(handler)
    }
  }, [query])

  return matches
}

/**
 * Hook для определения мобильной версии (ширина экрана <= 768px)
 */
export function useIsMobile(): boolean {
  return useMediaQuery('(max-width: 768px)')
}

